import adminApiFetch from './apiService';

const productCategoryService = {
  // 獲取分類列表（用於下拉選單）
  fetchList: async (params = {}) => {
    const queryParams = new URLSearchParams(params);
    const res = await adminApiFetch(`product_categories?${queryParams.toString()}`, {
      method: 'GET'
    });
    return res.json();
  },
};

export { productCategoryService };
export default productCategoryService;
